import { render, staticRenderFns } from "./fc-body.vue?vue&type=template&id=1bf91880"
import script from "./fc-body.vue?vue&type=script&lang=js"
export * from "./fc-body.vue?vue&type=script&lang=js"
import style0 from "./fc-body.vue?vue&type=style&index=0&id=1bf91880&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf91880')) {
      api.createRecord('1bf91880', component.options)
    } else {
      api.reload('1bf91880', component.options)
    }
    module.hot.accept("./fc-body.vue?vue&type=template&id=1bf91880", function () {
      api.rerender('1bf91880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FullCalendar/fc-body.vue"
export default component.exports